import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BankAccountBase } from '../bank-account-base';
import { PaymentService } from '../../../service/payment.service';
import { ModalRouteService } from '../../../service/modal-route.service';
import { AmorphicService } from '../../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';

@Component({
  selector: 'bank-account-form-coverpath',
  templateUrl: './bank-account-form.coverpath.html',
})
export class BankAccountFormComponentCoverpath extends BankAccountBase {
  constructor(
    paymentService: PaymentService,
    fb: FormBuilder,
    modalRouteService: ModalRouteService,
    amorphicService: AmorphicService
  ) {
    super(paymentService, fb, modalRouteService, amorphicService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
